import { settlementListAPI } from 'api/settlement'
import Footer from 'components/Footer'
import Header from 'components/Header'
import * as React from 'react'
import { Card } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import loginData from 'utilities/loginData'
import { getPaymentMethodLabel } from 'utilities/resources/options'
import { dateFormatter, numberFormat } from 'utilities/typeUtility'

interface PaymentItem {
  date: string
  title: string
  amount: string
  paymentMethod: string
}

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const [paymentItems, setPaymentItems] = React.useState<PaymentItem[]>([])
  React.useEffect(() => {
    if (!loginData.isLoggedIn()) {
      navigate('/')
    } else {
      settlementListAPI((result) => {
        const items: PaymentItem[] = []
        for (const settlement of result.settlements) {
          items.push({
            date: dateFormatter(settlement.date, 'yyyy/MM/dd'),
            title: settlement.type,
            amount: `${numberFormat(settlement.amount)}円`,
            paymentMethod: getPaymentMethodLabel(settlement.method),
          })
        }
        setPaymentItems(items)
      })
    }
  }, [navigate])
  return (
    <>
      <Header title="決済一覧" />
      <main>
        <section className="mx-4 my-5">
          {paymentItems.map(({ date, title, amount, paymentMethod }, index) => (
            <Card body className="border-0 mt-3" key={index}>
              <div className="item-date">{date}</div>
              <div className="d-flex mt-2 align-items-center">
                <div className="flex-fill item-title">{title}</div>
                <div className="text-end">{amount}</div>
              </div>
              <div className="mt-2">{paymentMethod}</div>
            </Card>
          ))}
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
